// Dependecies
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';

// Store
import termsAndCondictions from '../../store/termsAndCondictions';

// Hooks
import useLanguage from '../useLanguage';

// Helper
import { findIndexBySlug, makePath } from '../../helpers';

function useTermsAndConditions(slug) {
  const history = useHistory();
  const location = useLocation();
  const [terms, useTerms] = useState([]);
  const { locale, componentName } = useLanguage();
  const [termsStore, termsActions] = termsAndCondictions();
  const [t, i18n] = useTranslation('routers', { useSuspense: false });
  const [termAndCondition, useTermAndCondition] = useState({ slug: '' });
  const [authorizationData, useAuthorizationData] = useState({ slug: '' });
  const [termPoliticsPrivate, usePoliticsPrivate] = useState({ slug: '' });
  const [termPage, useTermPage] = useState({ es: { body: '' }, en: { body: '' } });

  // This effect is running when items are loaded or the locale is changed
  useEffect(() => {
    if (termsStore.itemsTerms[locale]) {
      const itemsTerms = termsStore.itemsTerms[locale];
      useTerms(itemsTerms);
      const myTerms = itemsTerms.find((itemTerms) => itemTerms.isTerm);
      const politics = itemsTerms.find((itemTerms) => itemTerms.isPolitics);
      const politicsPrivate = itemsTerms.find((itemTerms) => itemTerms.isPrivate);

      useTermAndCondition(myTerms || termAndCondition);
      useAuthorizationData(politics || authorizationData);
      usePoliticsPrivate(politicsPrivate || termPoliticsPrivate);
    }
  }, [termsStore.itemsTerms, locale]);

  const loadTermsPage = () => {
    if (termsStore.termsPages.length > 0) {
      const index = findIndexBySlug(termsStore.termsPages, locale, slug);

      if (index >= 0) {
        const itemPage = termsStore.termsPages[index || 0];
        if (itemPage[locale].slug === slug) {
          useTermPage(itemPage);
        } else {
          const nextSlug = itemPage[locale].slug;
          location.pathname = location.pathname.replace(slug, nextSlug);
          history.push(makePath(i18n.language, t(componentName), location));
        }
      }
    }
  };

  // When new page is loaded, this effect loads the new page called
  useEffect(() => {
    loadTermsPage();
  }, [termsStore.termsPages]);

  // This function handle if should get the page from the APi or not
  const loadFromSlug = () => {
    const index = findIndexBySlug(termsStore.termsPages, locale, slug);
    if (index < 0) {
      termsActions.getTermBySlug(slug, locale);
    } else {
      loadTermsPage();
    }
  };

  // This effect is running always that the slug changes
  useEffect(() => {
    if (slug) {
      loadFromSlug();
    }
  }, [slug]);

  return {
    termPage,
    terms,
    termAndCondition,
    authorizationData,
    termPoliticsPrivate,
    loadFromSlug,
    locale,
  };
}

export default useTermsAndConditions;
